import * as React from 'react'
import { I18nService } from '../../../../services/utils/i18n.service'
import { DescriptionContainer, DescriptionParagraph } from '../casting-styled.component'
import { CustomerPlanBase } from '../../../../services/json-schemas/base/customer_plan'
import { OfferedServiceBase } from '../../../../services/json-schemas/base/offered_service'

const i18nScoped = new I18nService(require('./customer-plan-description.component.yml'))

interface Props {
  customerPlan: Pick<CustomerPlanBase, 'description'> & { offered_service_ids: OfferedServiceBase['id'][] }
  offeredServices: Pick<OfferedServiceBase, 'id' | 'name'>[]
}

export default function CustomerPlanDescriptionComponent ({ customerPlan, offeredServices }: Props) {
  return <DescriptionContainer style={{ marginTop: '1em' }}>
    <DescriptionParagraph>
      { (customerPlan.description ?? '') !== '' && <div style={{ marginBottom: '0.5em' }} dangerouslySetInnerHTML={{ __html: customerPlan.description }} /> }

      <section>
        <strong style={{ fontSize: '1.1em' }}>{ i18nScoped.t('customer_plan_subscription_offered_services_label') }</strong>
        { customerPlan.offered_service_ids.length === 0 && i18nScoped.t('all_services') }
        { customerPlan.offered_service_ids.length > 0 && <ul>
          { customerPlan.offered_service_ids.map(osId => offeredServices.find(_ => _.id === osId)).filter(Boolean).map(offeredService => <li key={ offeredService.id }>{ offeredService.name }</li>) }
          { customerPlan.offered_service_ids.filter(osId => offeredServices.every(_ => _.id !== osId)).length > 0 && <li>{ i18nScoped.t('and_x_other_services', { count: customerPlan.offered_service_ids.filter(osId => offeredServices.every(_ => _.id !== osId)).length }) }</li> }
        </ul> }
      </section>
    </DescriptionParagraph>
  </DescriptionContainer>
}